import { useState } from "react";

export enum STEP {
  NEXT = 1,
  REGISTER = 2,
  LOGIN = 3,
}

export interface UseAuth {
  step: STEP;
  onNext: (email: string) => void;
  email: string;
  onLogin: () => void;
  onRegister: () => void;
}

const useAuth = (): UseAuth => {
  const [step, setStep] = useState<STEP>(STEP.NEXT);
  const [email, setEmail] = useState<string>("");

  const onRegister = () => {
    setEmail("");
    setStep(STEP.NEXT);
  };

  const onNext = (email: string) => {
    setEmail(email);
    setStep(STEP.REGISTER);
  };

  const onLogin = () => {
    setStep(STEP.LOGIN);
  };

  return {
    step,
    onNext,
    email,
    onLogin,
    onRegister,
  };
};

export default useAuth;
